module.exports = __webpack_public_path__ + "img/title1.334666d0.png";